module.exports = __webpack_public_path__ + "static/paris-006-1e827c9286cee1a6d70de4b8333810b7.jpg";